import React, { useState } from 'react';
import { InputAreaProps } from '../types';
import { playSelectSound } from '../utils/sound';
import PirateDictionaryPopup from './PirateDictionaryPopup';

// InputArea Component
const InputArea = ({ gamePhase, isPlayerTurn, isLoading, playerInput, handleInputChange, handleSubmit, handlePlayerInsult, insertTextAtCursor }: InputAreaProps) => {
    const [dictionaryOpen, setDictionaryOpen] = useState(false);

    // Enhanced handlers with sound effects
    const handleSubmitWithSound = (e: React.FormEvent<HTMLFormElement>) => {
        playSelectSound();
        handleSubmit(e);
    };

    const handlePlayerInsultWithSound = (e: React.FormEvent<HTMLFormElement>) => {
        playSelectSound();
        handlePlayerInsult(e);
    };

    const handleToggleDictionary = () => {
        playSelectSound();
        setDictionaryOpen(!dictionaryOpen);
    };

    const handleSelectTerm = (term: string) => {
        if (insertTextAtCursor) {
            insertTextAtCursor(term);
        }
        setDictionaryOpen(false);
    };

    return (
        <div >
            {isPlayerTurn && !isLoading && (
                <>
                    <form onSubmit={gamePhase === 'playerInsult' ? handlePlayerInsultWithSound : handleSubmitWithSound} className="nes-field">
                        <textarea
                            value={playerInput}
                            onChange={handleInputChange}
                            placeholder={gamePhase === 'playerInsult' ? "Enter your pirate insult..." : "Enter your comeback..."}
                            className="player-input nes-textarea"
                            rows={2}
                            style={{ resize: 'none', marginBottom: '8px' }}
                        />
                        <button
                            type="button"
                            className="dictionary-button nes-btn is-primary is-small"
                            onClick={handleToggleDictionary}
                            title="Pirate Dictionary"
                        >
                            <i className="nes-icon is-small book"></i> 🏴‍☠️ Dictionary
                        </button>
                        <button type="submit" className="submit-button nes-btn is-warning is-small">
                            {gamePhase === 'playerInsult' ? "Insult!" : "Respond!"}
                        </button>
                    </form>
                    <PirateDictionaryPopup
                        isOpen={dictionaryOpen}
                        onClose={() => setDictionaryOpen(false)}
                        onSelectTerm={handleSelectTerm}
                    />
                </>
            )}
            {(isLoading) && (
                <div className="ai-thinking nes-text is-disabled">
                    <i className="nes-icon is-small star"></i> {isLoading ? "Consulting the pirate AI..." : "The pirate is thinking of a response..."}
                </div>
            )}
        </div>
    );
};

export default InputArea;
